import React, { useState, useEffect } from 'react';
import { Route, Routes, useParams } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Alert, Container, Tabs, Loader } from '@itds/elements/index.js';

import H1 from '@brokerage/components/H1';

import CarrierForm from './CarrierForm';
import ProductList from './products/List';

import { Api } from '@brokerage/utils/Api';

const Show = () => {
  const params = useParams();

  const [carrier, setCarrier] = useState({});
  const [loading, setLoading] = useState(true);
  const [success_message, setSuccessMessage] = useState();
  const [error_message, setErrorMessage] = useState();

  useEffect(() => {
    loadCarrier();
  }, []);

  const loadCarrier = () => {
    setLoading(true);

    Api.loadCarrier(params.carrier_id).then(response => {
      setCarrier(response.data);
      setLoading(false);
    });
  };

  const onSave = response => {
    loadCarrier();
    setLoading(false);
    setTimeout(() => {
      setErrorMessage(null);
      setSuccessMessage(null);
    }, 2000);

    return response === 'success'
      ? setSuccessMessage('Carrier updated successfully')
      : setErrorMessage('Unable to update Carrier');
  };

  const child_props = {
    carrier,
    onSave
  };

  return loading ? (
    <Loader />
  ) : (
    <Container>
      {error_message ? <Alert type='error'>{error_message}</Alert> : null}
      {success_message ? <Alert type='success'>{success_message}</Alert> : null}

      <H1>{carrier.name}</H1>

      <Tabs
        tabs={[
          {
            label: 'General',
            isActive: window.location.hash.includes('general'),
            to: 'general'
          },
          {
            label: 'Products',
            isActive: window.location.hash.includes('products'),
            to: 'products'
          }
        ]}
      />

      <div style={{ padding: '40px 20px' }}>
        <Routes>
          <Route element={<CarrierForm {...child_props} />} path='general' />.
          <Route element={<ProductList {...child_props} />} path='products' />
        </Routes>
      </div>
    </Container>
  );
};

Show.propTypes = {
  name: PropTypes.string
};

export default Show;
